import axios from "axios";

const DeleteAxios = async function (props = {}) {
  var gett = localStorage.getItem("isloggedIn");
  var customerNo = localStorage.getItem("customerNumber");
  var userId = localStorage.getItem("userId");
  var locales = localStorage.getItem("locales") === "en" ? "en-IN" : "pt-Br"

  let congData = JSON.stringify({
    customerNumber: customerNo,
    userId: userId,
    customer_no: +customerNo,
    user_id: +userId,
    customerNo: +customerNo,
    ...props.payload,
  });

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    : `${process.env.REACT_APP_MASTER_API}/${props.url}/${props.uniqueId}`;

  if (props.completeURL) {
    try {
      return new Promise((respolve, reject) => {
        axios
          .delete(apiURL, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
            params: {
              customerNumber: customerNo,
              userId: userId,
              customer_no: +customerNo,
              user_id: +userId,
              customerNo: +customerNo,
            },
            data: congData,
          })
          .then((res) => {
            // console.log("deleted", res);
            respolve(res);
          })
          .catch((err) => {
            // console.log("error while deletion", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  } else {
    try {
      return new Promise((respolve, reject) => {
        axios
          .delete(apiURL, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
            data: congData,
          })
          .then((res) => {
            // console.log("deleted", res);
            if (res.data.status === 200) {
              respolve(res);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            console.log("error while deletion", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
};
export default DeleteAxios;
